"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.upgrade.message': 'Upgrade your account plan to access this feature.',
    'limits.upgrade.link': 'Upgrade Now',
};
